import React, { ReactNode } from "react";
import "./flyoutlayout.less";

type Align = "flex-start" | "center" | "flex-end" | "stretch";
type Justify = "flex-start" | "center" | "flex-end" | "space-between";

interface FlyoutLayoutProps {
  displayName: string; // e.g. "cmp-otpform"
  isOpen: boolean;
  closeModal: () => void;
  children: ReactNode;
  contentPadding?: string; // inline override for padding
  contentAlign?: Align;
  contentJustify?: Justify;
}

const FlyoutLayout: React.FC<FlyoutLayoutProps> = ({
  displayName,
  isOpen,
  closeModal,
  children,
  contentPadding = "120px 32px",
  contentAlign = "center",
  contentJustify = "flex-start",
}) => {
  return (
    <div className={displayName} aria-hidden={!isOpen}>
      <div
        className={`${displayName}__overlay flyout-overlay ${
          isOpen ? "open" : ""
        }`}
        onClick={closeModal}
      />

      <div
        className={`${displayName}__flyout flyout-panel ${
          isOpen ? "open" : ""
        }`}
        role="dialog"
        aria-modal="true"
      >
        <div
          className={`${displayName}__content flyout-content`}
          style={{
            padding: contentPadding,
            alignItems: contentAlign,
            justifyContent: contentJustify,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            aria-label="Close"
            className={`${displayName}__close flyout-close`}
            onClick={closeModal}
          >
            ×
          </button>

          {children}
        </div>
      </div>
    </div>
  );
};

export default FlyoutLayout;
